import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const KelasManager = ({ token }) => {
  const [kelasList, setKelasList] = useState([]);
  const [guruList, setGuruList] = useState([]);
  const [jadwalList, setJadwalList] = useState([]); 
  const [loading, setLoading] = useState(true);
  
  // Form State
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [namaKelas, setNamaKelas] = useState('');
  const [waliKelasId, setWaliKelasId] = useState('');

  // Modal Jadwal State
  const [selectedJadwalKelas, setSelectedJadwalKelas] = useState(null); 
  const [viewJadwalModal, setViewJadwalModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [token]);

  const fetchData = async () => {
    setLoading(true);
    try {
        const [resKelas, resGuru, resJadwal] = await Promise.all([
            axios.get('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { headers: { Authorization: `Bearer ${token}` } }),
            axios.get('https://sijapan.sman10fajarharapan.sch.id/api/guru', { headers: { Authorization: `Bearer ${token}` } }),
            axios.get('https://sijapan.sman10fajarharapan.sch.id/api/jadwal', { headers: { Authorization: `Bearer ${token}` } })
        ]);
        setKelasList(resKelas.data);
        setGuruList(resGuru.data);
        setJadwalList(resJadwal.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
        if (isEditing) {
            await axios.put(`https://sijapan.sman10fajarharapan.sch.id/api/kelas/${editId}`, { nama_kelas: namaKelas, wali_kelas_id: waliKelasId }, { headers: { Authorization: `Bearer ${token}` } });
            Swal.fire('Sukses', 'Data kelas diupdate', 'success');
        } else {
            await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { nama_kelas: namaKelas, wali_kelas_id: waliKelasId }, { headers: { Authorization: `Bearer ${token}` } });
            Swal.fire('Sukses', 'Kelas baru ditambahkan', 'success');
        }
        resetForm();
        fetchData();
    } catch (err) { Swal.fire('Gagal', 'Terjadi kesalahan', 'error'); }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Hapus kelas ini? Data siswa di dalamnya tidak akan terhapus, tapi kelasnya jadi kosong.')) {
        try {
            await axios.delete(`https://sijapan.sman10fajarharapan.sch.id/api/kelas/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            fetchData();
        } catch (err) { alert('Gagal hapus'); }
    }
  };

  const handleEdit = (k) => {
      setIsEditing(true);
      setEditId(k.id);
      setNamaKelas(k.nama_kelas);
      setWaliKelasId(k.wali_kelas_id || '');
  };

  const resetForm = () => {
      setIsEditing(false);
      setEditId(null);
      setNamaKelas('');
      setWaliKelasId('');
  };

  // --- FITUR PINTASAN ---
  const goToSiswa = (nama_kelas) => {
      navigate('/siswa', { state: { filterKelas: nama_kelas } });
  };

  const openJadwal = (k) => {
      setSelectedJadwalKelas(k.nama_kelas);
      setViewJadwalModal(true);
  };

  const jadwalTerpilih = jadwalList.filter(j => j.nama_kelas === selectedJadwalKelas);

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b', marginBottom: '20px' }}>🏫 Manajemen Kelas & Wali Kelas</h2>

      {/* FORM INPUT */}
      <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', marginBottom: '30px' }}>
          <h4 style={{ margin: '0 0 15px', color: '#4361ee' }}>{isEditing ? '✏️ Edit Kelas' : '➕ Tambah Kelas Baru'}</h4>
          <form onSubmit={handleSave} style={{ display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
              <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#64748b' }}>Nama Kelas</label>
                  <input type="text" placeholder="Contoh: X MIPA 1" value={namaKelas} onChange={e => setNamaKelas(e.target.value)} required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
              </div>
              <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#64748b' }}>Wali Kelas</label>
                  <select value={waliKelasId} onChange={e => setWaliKelasId(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                      <option value="">-- Pilih Guru --</option>
                      {guruList.map(g => <option key={g.id} value={g.id}>{g.nama}</option>)}
                  </select>
              </div>
              <button type="submit" style={{ padding: '10px 20px', background: isEditing ? '#f59e0b' : '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>{isEditing ? 'Update' : 'Simpan'}</button>
              {isEditing && <button type="button" onClick={resetForm} style={{ padding: '10px 20px', background: '#94a3b8', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>Batal</button>}
          </form>
      </div>

      {/* TABEL DATA KELAS */}
      {loading ? <p>Loading...</p> : (
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', textAlign: 'left' }}>
                <th style={{ padding: '15px', color: '#475569' }}>Nama Kelas</th>
                <th style={{ padding: '15px', color: '#475569' }}>Wali Kelas</th>
                <th style={{ padding: '15px', color: '#475569' }}>Statistik Siswa</th>
                <th style={{ padding: '15px', textAlign: 'center', color: '#475569' }}>Pintasan</th>
                <th style={{ padding: '15px', textAlign: 'center', color: '#475569' }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {kelasList.map((k) => (
                <tr key={k.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '15px', fontWeight: 'bold', color: '#334155' }}>{k.nama_kelas}</td>
                  <td style={{ padding: '15px' }}>
                      {k.nama_wali_kelas ? (
                          <span style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>👨‍🏫 {k.nama_wali_kelas}</span>
                      ) : <span style={{ color: '#94a3b8', fontSize: '12px', fontStyle: 'italic' }}>- Belum ada -</span>}
                  </td>
                  <td style={{ padding: '15px' }}>
                      <div style={{ display: 'flex', gap: '8px', fontSize: '12px' }}>
                          <span title="Total Siswa" style={{ background: '#e2e8f0', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>👥 {k.total_siswa}</span>
                          <span title="Laki-laki" style={{ background: '#dbeafe', color: '#1e40af', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>L: {k.jml_l}</span>
                          <span title="Perempuan" style={{ background: '#fce7f3', color: '#9d174d', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>P: {k.jml_p}</span>
                      </div>
                  </td>
                  <td style={{ padding: '15px', textAlign: 'center' }}>
                      <button onClick={() => goToSiswa(k.nama_kelas)} title="Lihat Siswa Kelas Ini" style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '6px 10px', borderRadius: '6px', marginRight: '5px', cursor: 'pointer' }}>👥</button>
                      <button onClick={() => openJadwal(k)} title="Lihat Jadwal Kelas Ini" style={{ background: '#8b5cf6', color: 'white', border: 'none', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer' }}>📅</button>
                  </td>
                  <td style={{ padding: '15px', textAlign: 'center' }}>
                      <button onClick={() => handleEdit(k)} style={{ marginRight: '5px', padding: '6px 10px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>✏️</button>
                      <button onClick={() => handleDelete(k.id)} style={{ padding: '6px 10px', background: '#ef476f', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* --- MODAL POPUP JADWAL --- */}
      {viewJadwalModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
              <div style={{ background: 'white', width: '500px', borderRadius: '15px', padding: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>
                      <h3 style={{ margin: 0, color: '#1e293b' }}>📅 Jadwal {selectedJadwalKelas}</h3>
                      <button onClick={() => setViewJadwalModal(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
                  </div>
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {jadwalTerpilih.length === 0 ? (
                          <p style={{ textAlign: 'center', color: '#94a3b8' }}>Belum ada jadwal untuk kelas ini.</p>
                      ) : (
                          <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                              <thead>
                                  <tr style={{ background: '#f1f5f9' }}>
                                      <th style={{ padding: '8px', textAlign: 'left' }}>Hari</th>
                                      <th style={{ padding: '8px', textAlign: 'left' }}>Jam</th>
                                      <th style={{ padding: '8px', textAlign: 'left' }}>Mapel & Guru</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {jadwalTerpilih.map((j, idx) => (
                                      <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                          <td style={{ padding: '8px', fontWeight: 'bold' }}>{j.hari}</td>
                                          <td style={{ padding: '8px' }}>{j.jam_mulai.slice(0,5)} - {j.jam_selesai.slice(0,5)}</td>
                                          <td style={{ padding: '8px' }}>
                                              <div style={{ fontWeight: 'bold', color: '#334155' }}>{j.mapel}</div>
                                              <div style={{ fontSize: '11px', color: '#64748b' }}>{j.nama_guru}</div>
                                          </td>
                                      </tr>
                                  ))}
                              </tbody>
                          </table>
                      )}
                  </div>
              </div>
          </div>
      )}
    </div>
  );
};

export default KelasManager;